import React, { createContext, useContext, useEffect, useState } from "react";
import { logger } from "../lib/logger";

const translations = {
  en: {
    brand: "OMR PERFUMER",
    nav_home: "Home",
    nav_shop: "Shop",
    nav_story: "Our Story",
    nav_perfumer: "The Perfumer",
    nav_contact: "Contact",
    nav_lab: "Experiments",
    perfumer_role: "Independent Perfumer",
    lang_toggle: "العربية",
    search: "Search",
    cart: "Bag",
    account: "Account",
    admin: "Admin",
    login: "Login",
    register: "Create Account",
    logout: "Logout",
    // hero / home
    shop_fragrances: "Shop Fragrances",
    discover: "Discover OMR",
    story_of_omr: "The Story of OMR",
    featured: "Featured Fragrance",
    featured_sub: "The inaugural composition from our Abu Dhabi atelier.",
    view_product: "View Fragrance",
    house_line: "An independent artisanal perfume house from Abu Dhabi.",
    // product
    add_to_bag: "Add to Bag",
    buy_now: "Buy Now",
    quantity: "Quantity",
    size: "Size",
    concentration: "Concentration",
    availability: "Availability",
    notes: "Fragrance Notes",
    perfumer_note: "Perfumer's Note",
    shipping_info: "Shipping Information",
    product_details: "Product Details",
    quick_view: "Quick View",
    limited_release: "Limited Release",
    sold_out: "Sold Out",
    coming_soon: "Coming Soon",
    available: "Available",
    in_stock: "In Stock",
    units_left: "units remaining",
    only_left_pre: "Only",
    only_left_post: "left",
    price_tba: "Price on release",
    olfactive_family: "Olfactive Family",
    scent_profile: "Scent Profile",
    ingredients: "Ingredients",
    fragrance_description: "The Composition",
    natural_materials: "Natural Raw Materials",
    natural_materials_sub: "Latte Oud contains a high proportion of carefully selected natural materials, and they form an essential part of the fragrance's structure and character. The naturals weren't used simply to raise their percentage, but for the complexity, gradation and texture they add — from the depth of the coffee through to the woody, earthy and resinous facets.",
    // shop
    shop_title: "The Collection",
    shop_sub: "Small-batch fragrances, composed and released in limited quantities.",
    all: "All",
    // cart
    your_bag: "Your Bag",
    empty_bag: "Your bag is empty.",
    continue_shopping: "Continue Shopping",
    remove: "Remove",
    subtotal: "Subtotal",
    shipping: "Shipping",
    total: "Total",
    checkout: "Checkout",
    order_total: "Order Total",
    calculated_checkout: "Calculated at checkout",
    // checkout
    checkout_title: "Checkout",
    contact_details: "Contact Details",
    shipping_address: "Shipping Address",
    full_name: "Full Name",
    email: "Email",
    phone: "Phone Number",
    country: "Country",
    emirate: "Emirate",
    city: "City",
    address: "Address",
    building: "Building / Villa",
    apartment: "Apartment / Room",
    delivery_notes: "Delivery Notes",
    discount_code: "Discount code",
    apply: "Apply",
    order_summary: "Order Summary",
    place_order: "Proceed to Payment",
    consent_pre: "I confirm that I have read and agree to the",
    must_agree: "Please agree to the policies before proceeding.",
    sales_closed_msg: "Purchasing is currently closed. Please check back soon.",
    payment_method: "Payment Method",
    payment_note: "You will be redirected to a secure Ziina payment page. Card, Apple Pay and Google Pay are accepted, charged in UAE dirhams (AED). Your order is confirmed and your fragrance reserved the moment payment succeeds.",
    // confirmation
    order_received: "Order Received",
    thank_you: "Thank you for your order.",
    order_number: "Order Number",
    order_status: "Order Status",
    delivery_address: "Delivery Address",
    amount: "Amount",
    products: "Products",
    status_pending_payment: "Awaiting Payment",
    status_paid: "Paid",
    status_processing: "Processing",
    status_shipped: "Shipped",
    status_delivered: "Delivered",
    status_cancelled: "Cancelled",
    // account
    profile: "Profile",
    orders: "Orders",
    addresses: "Addresses",
    no_orders: "You have no orders yet.",
    // auth
    password_label: "Password",
    name: "Name",
    have_account: "Already have an account?",
    no_account: "Don't have an account?",
    guest_checkout: "Continue as Guest",
    // contact
    contact_title: "Contact",
    contact_sub: "For enquiries, collaborations and press.",
    send_message: "Send Message",
    message: "Message",
    // footer
    footer_tagline: "Independent niche perfumery from Abu Dhabi.",
    shipping_delivery: "Shipping & Delivery",
    returns: "Returns & Refunds",
    privacy: "Privacy Policy",
    terms: "Terms, Conditions & Safety",
    instagram: "Instagram",
    rights: "All rights reserved.",
    location: "Abu Dhabi, United Arab Emirates",
    added_to_bag: "Added to your bag",
    max_stock: "Not enough stock available",
    intl_note: "International orders ship worldwide via DHL. Delivery times vary by destination. Duties and taxes may apply on arrival.",
    intl_currency_note: "International orders are charged in USD.",
    intl_soon: "International shipping unavailable",
    prices_in: "Prices in",
    shipping_tba: "Calculated later",
    free_shipping: "Free",
    estimated_label: "estimated",
    view_details: "View fragrance details",
    gcc_note: "Shipped to GCC countries. Land is the most economical option; air is faster. Price depends on the number of bottles (about 0.5 kg each).",
    area: "Emirate / area",
    choose_area: "Choose your emirate / area",
    shipping_method: "Shipping method",
    ship_land: "Land · economy",
    ship_air: "Air · express",
    verifying_payment: "Confirming your payment",
    please_wait: "Please wait a moment…",
    payment_processing: "Payment is processing",
    payment_processing_note: "Your payment is being confirmed. You can view the status in your account orders shortly.",
    payment_cancelled: "Payment Cancelled",
    payment_cancelled_note: "Your payment was not completed. Your bag is still saved — you can try again.",
    payment_received_note: "Payment received. A confirmation email is on its way. We will notify you once your fragrance is dispatched.",
    // reviews
    reviews_title: "Reviews",    reviews_none: "No reviews yet. Be the first to share your impression.",
    write_review: "Write a Review",
    your_rating: "Your Rating",
    your_review: "Your Review",
    submit_review: "Submit Review",
    review_thanks: "Thank you for your review.",
    review_name_ph: "Your name",
    review_text_ph: "Share your experience with this fragrance…",
    based_on: "based on",
    reviews_count_label: "reviews",
    reviews_count_label_one: "review",
    review_error: "Please add a rating and a short note.",
    // newsletter
    newsletter_title: "Join the List",
    newsletter_sub: "Be the first to know about new releases and limited batches.",
    newsletter_ph: "Email address",
    newsletter_btn: "Subscribe",
    newsletter_thanks: "You're on the list.",
    newsletter_error: "Please enter a valid email.",
    err_too_many: "Too many attempts. Please try again in a few minutes.",
    err_network: "Connection problem. Please check your internet and try again.",
    notify_title: "Notify me when available",
    notify_sub: "Leave your email and we'll alert you the moment this fragrance is released.",
    notify_btn: "Notify me",
    notify_thanks: "Done! We'll email you as soon as it's available.",
    customs_notice: "Customs duties or import taxes may apply in your country. If so, an additional amount will be collected by the courier on delivery and is not included in this total.",
    // welcome / auth gate
    welcome_title: "An Independent House of Fragrance",
    welcome_sub: "Please sign in or create an account to explore the collection.",
    welcome_note: "Access to the boutique is reserved for members. Creating an account takes less than a minute.",
    main_accords: "Main Accords",
    advisor_cta: "Fragrance Advisor",
    advisor_title: "Fragrance Advisor",
    advisor_sub: "Powered by AI",
    advisor_intro: "Hello 👋 Tell me what you love — sweet, woody, fresh, an occasion — and I'll suggest the perfect OMR fragrance for you.",
    advisor_placeholder: "e.g. I want something warm and sweet…",
    advisor_thinking: "Thinking…",
    advisor_error: "The advisor is unavailable right now. Please try again.",
    // admin assistant
    assistant_tab: "AI Assistant",
    assistant_title: "Your Store Assistant",
    assistant_sub: "Ask me to write or translate descriptions, change prices, stock, status and more — in Arabic or English.",
    assistant_placeholder: "Ask anything… e.g. change Latte Oud price to 290",
    assistant_send: "Send",
    assistant_new: "New chat",
    assistant_thinking: "Thinking…",
    assistant_error: "The assistant is unavailable right now. Please try again.",
    assistant_intro: "Hi 👋 I can help you manage the store. Try: “write a shorter Arabic description for Latte Oud”, or “set stock to 40”.",
  },
  ar: {
    brand: "OMR PERFUMER",
    nav_home: "الرئيسية",
    nav_shop: "المتجر",
    nav_story: "قصتنا",
    nav_perfumer: "صانع العطر",
    nav_contact: "تواصل",
    nav_lab: "التجارب",
    perfumer_role: "صانع عطور مستقل",
    lang_toggle: "English",
    search: "بحث",
    cart: "الحقيبة",
    account: "حسابي",
    admin: "الإدارة",
    login: "تسجيل الدخول",
    register: "إنشاء حساب",
    logout: "تسجيل الخروج",
    shop_fragrances: "تسوق العطور",
    discover: "اكتشف OMR",
    story_of_omr: "قصة OMR",
    featured: "العطر المميز",
    featured_sub: "أول تركيبة من مشغلنا في أبوظبي.",
    view_product: "عرض العطر",
    house_line: "دار عطور حرفية مستقلة من أبوظبي.",
    add_to_bag: "أضف إلى الحقيبة",
    buy_now: "اشترِ الآن",
    quantity: "الكمية",
    size: "الحجم",
    concentration: "التركيز",
    availability: "التوفر",
    notes: "مكونات العطر",
    perfumer_note: "ملاحظة صانع العطر",
    shipping_info: "معلومات الشحن",
    product_details: "تفاصيل المنتج",
    quick_view: "عرض سريع",
    limited_release: "إصدار محدود",
    sold_out: "نفدت الكمية",
    coming_soon: "قريباً",
    available: "متوفر",
    in_stock: "متوفر",
    units_left: "قطعة متبقية",
    only_left_pre: "متبقّي",
    only_left_post: "قطعة فقط",
    price_tba: "السعر عند الإصدار",
    olfactive_family: "العائلة العطرية",
    scent_profile: "بروفايل الرائحة",
    ingredients: "المكوّنات",
    fragrance_description: "التركيبة",
    natural_materials: "مواد طبيعية",
    natural_materials_sub: "تحتوي تركيبة Latte Oud على نسبة مرتفعة من المواد الطبيعية المختارة بعناية، وتشكل هذه المواد جزءًا أساسيًا من بنية العطر وشخصيته. لم تُستخدم المواد الطبيعية لمجرد رفع نسبتها داخل التركيبة، بل لما تضيفه من تعقيد، تدرج وملمس للرائحة؛ بدايةً من عمق القهوة وصولًا إلى الجوانب الخشبية والترابية والراتنجية.",
    shop_title: "المجموعة",
    shop_sub: "عطور بكميات صغيرة، تُصاغ وتُصدر بكميات محدودة.",
    all: "الكل",
    your_bag: "حقيبتك",
    empty_bag: "حقيبتك فارغة.",
    continue_shopping: "متابعة التسوق",
    remove: "إزالة",
    subtotal: "المجموع الفرعي",
    shipping: "الشحن",
    total: "الإجمالي",
    checkout: "إتمام الشراء",
    order_total: "إجمالي الطلب",
    calculated_checkout: "يُحتسب عند الدفع",
    checkout_title: "إتمام الشراء",
    contact_details: "بيانات التواصل",
    shipping_address: "عنوان الشحن",
    full_name: "الاسم الكامل",
    email: "البريد الإلكتروني",
    phone: "رقم الهاتف",
    country: "الدولة",
    emirate: "الإمارة",
    city: "المدينة",
    address: "العنوان",
    building: "المبنى / الفيلا",
    apartment: "الشقة / الغرفة",
    delivery_notes: "ملاحظات التوصيل",
    discount_code: "رمز الخصم",
    apply: "تطبيق",
    order_summary: "ملخص الطلب",
    place_order: "المتابعة إلى الدفع",
    consent_pre: "أقرّ بأنني قرأت ووافقت على",
    must_agree: "يرجى الموافقة على السياسات قبل المتابعة.",
    sales_closed_msg: "الشراء مغلق حالياً. يرجى العودة قريباً.",
    payment_method: "طريقة الدفع",
    payment_note: "سيتم تحويلك إلى صفحة دفع آمنة عبر Ziina. تُقبل البطاقة وApple Pay وGoogle Pay، ويتم الخصم بالدرهم الإماراتي. يتم تأكيد طلبك وحجز عطرك فور نجاح الدفع.",
    order_received: "تم استلام الطلب",
    thank_you: "شكراً لطلبك.",
    order_number: "رقم الطلب",
    order_status: "حالة الطلب",
    delivery_address: "عنوان التوصيل",
    amount: "المبلغ",
    products: "المنتجات",
    status_pending_payment: "بانتظار الدفع",
    status_paid: "مدفوع",
    status_processing: "قيد المعالجة",
    status_shipped: "تم الشحن",
    status_delivered: "تم التوصيل",
    status_cancelled: "ملغى",
    profile: "الملف الشخصي",
    orders: "الطلبات",
    addresses: "العناوين",
    no_orders: "لا توجد لديك طلبات بعد.",
    password_label: "كلمة المرور",
    name: "الاسم",
    have_account: "لديك حساب بالفعل؟",
    no_account: "ليس لديك حساب؟",
    guest_checkout: "المتابعة كضيف",
    contact_title: "تواصل معنا",
    contact_sub: "للاستفسارات والتعاون والصحافة.",
    send_message: "إرسال الرسالة",
    message: "الرسالة",
    footer_tagline: "عطور مستقلة متخصصة من أبوظبي.",
    shipping_delivery: "الشحن والتوصيل",
    returns: "الإرجاع والاسترداد",
    privacy: "سياسة الخصوصية",
    terms: "الشروط والسلامة",
    instagram: "إنستغرام",
    rights: "جميع الحقوق محفوظة.",
    location: "أبوظبي، الإمارات العربية المتحدة",
    added_to_bag: "تمت الإضافة إلى حقيبتك",
    max_stock: "لا توجد كمية كافية",
    intl_note: "تُشحن الطلبات الدولية إلى جميع أنحاء العالم عبر DHL. تختلف مدة التوصيل حسب الوجهة. قد تُطبق رسوم جمركية وضرائب عند الوصول.",
    intl_currency_note: "تُحتسب الطلبات الدولية بالدولار الأمريكي.",
    intl_soon: "الشحن الدولي غير متاح",
    prices_in: "الأسعار بعملة",
    shipping_tba: "يُحتسب لاحقاً",
    free_shipping: "مجاني",
    estimated_label: "تقديري",
    view_details: "تفاصيل العطر",
    gcc_note: "يُشحن إلى دول الخليج. الشحن البري هو الأوفر، والجوي أسرع. يعتمد السعر على عدد الزجاجات (حوالي ٠٫٥ كغ لكل زجاجة).",
    area: "الإمارة / المنطقة",
    choose_area: "اختر الإمارة / المنطقة",
    shipping_method: "طريقة الشحن",
    ship_land: "بري · اقتصادي",
    ship_air: "جوي · سريع",
    verifying_payment: "جارٍ تأكيد الدفع",
    please_wait: "يرجى الانتظار لحظة…",
    payment_processing: "جارٍ معالجة الدفع",
    payment_processing_note: "يتم تأكيد دفعتك. يمكنك عرض الحالة في طلبات حسابك قريباً.",
    payment_cancelled: "تم إلغاء الدفع",
    payment_cancelled_note: "لم يكتمل الدفع. لا تزال حقيبتك محفوظة — يمكنك المحاولة مرة أخرى.",
    payment_received_note: "تم استلام الدفع. رسالة تأكيد في طريقها إليك. سنعلمك فور شحن عطرك.",
    // reviews
    reviews_title: "التقييمات",
    reviews_none: "لا توجد تقييمات بعد. كن أول من يشارك انطباعه.",
    write_review: "اكتب تقييماً",
    your_rating: "تقييمك",
    your_review: "تعليقك",
    submit_review: "إرسال التقييم",
    review_thanks: "شكراً لتقييمك.",
    review_name_ph: "اسمك",
    review_text_ph: "شاركنا تجربتك مع هذا العطر…",
    based_on: "بناءً على",
    reviews_count_label: "تقييم",
    reviews_count_label_one: "تقييم",
    review_error: "يرجى إضافة تقييم وملاحظة قصيرة.",
    // newsletter
    newsletter_title: "انضم إلى القائمة",
    newsletter_sub: "كن أول من يعرف عن الإصدارات الجديدة والكميات المحدودة.",
    newsletter_ph: "البريد الإلكتروني",
    newsletter_btn: "اشترك",
    newsletter_thanks: "تم تسجيلك في القائمة.",
    newsletter_error: "يرجى إدخال بريد إلكتروني صحيح.",
    err_too_many: "محاولات كثيرة. يرجى المحاولة بعد دقائق.",
    err_network: "مشكلة في الاتصال. تأكد من الإنترنت وحاول مرة أخرى.",
    notify_title: "نبّهني عند التوفّر",
    notify_sub: "اترك بريدك الإلكتروني وسنرسل لك تنبيهاً فور نزول هذا العطر.",
    notify_btn: "نبّهني",
    notify_thanks: "تم! سنراسلك فور توفّر العطر.",
    customs_notice: "قد تُطبّق رسوم جمركية أو ضرائب استيراد في دولتك. في هذه الحالة يُحصّل الناقل مبلغاً إضافياً عند التوصيل، وهو غير مشمول في هذا الإجمالي.",
    // welcome / auth gate
    welcome_title: "دار عطورٍ مستقلة",
    welcome_sub: "الرجاء تسجيل الدخول أو إنشاء حساب لاستكشاف المجموعة.",
    welcome_note: "الدخول إلى المتجر مخصّص للأعضاء. إنشاء الحساب يستغرق أقل من دقيقة.",
    main_accords: "النوتات الرئيسية",
    advisor_cta: "مستشار العطور",
    advisor_title: "مستشار العطور",
    advisor_sub: "مدعوم بالذكاء الاصطناعي",
    advisor_intro: "مرحباً 👋 قل لي وش تحب — حلو، خشبي، منعش، أو مناسبة معيّنة — وأرشّح لك عطر OMR الأنسب.",
    advisor_placeholder: "مثال: أبي شيء دافئ وحلو…",
    advisor_thinking: "جارٍ التفكير…",
    advisor_error: "المستشار غير متاح حالياً. حاول مرة أخرى.",
    // admin assistant
    assistant_tab: "المساعد الذكي",
    assistant_title: "مساعد متجرك",
    assistant_sub: "اطلب مني كتابة أو ترجمة الأوصاف، وتغيير الأسعار والمخزون والحالة والمزيد — بالعربية أو الإنجليزية.",
    assistant_placeholder: "اسأل أي شيء… مثال: غيّر سعر لاتيه عود إلى 290",
    assistant_send: "إرسال",
    assistant_new: "محادثة جديدة",
    assistant_thinking: "جارٍ التفكير…",
    assistant_error: "المساعد غير متاح حالياً. حاول مرة أخرى.",
    assistant_intro: "مرحباً 👋 أقدر أساعدك في إدارة المتجر. جرّب: «اكتب وصفاً عربياً أقصر للاتيه عود»، أو «اجعل المخزون 40».",
  },
};

const emirates_en = ["Abu Dhabi", "Dubai", "Sharjah", "Ajman", "Ras Al Khaimah", "Fujairah", "Umm Al Quwain"];
const emirates_ar = {
  "Abu Dhabi": "أبوظبي", "Dubai": "دبي", "Sharjah": "الشارقة", "Ajman": "عجمان",
  "Ras Al Khaimah": "رأس الخيمة", "Fujairah": "الفجيرة", "Umm Al Quwain": "أم القيوين",
};

const LanguageContext = createContext();

const CURRENCIES = ["AED", "SAR", "KWD", "BHD", "QAR", "OMR", "USD", "EUR"];
// Base currency is AED. GCC currencies are USD-pegged, so fixed rates are accurate.
const CURRENCY_RATES = { AED: 1, SAR: 1.0404, KWD: 0.08517, BHD: 0.10404, QAR: 1.0098, OMR: 0.1068, USD: 0.2777, EUR: 0.257 };
const CURRENCY_SYMBOL = { AED: "AED", SAR: "SAR", KWD: "KWD", BHD: "BHD", QAR: "QAR", OMR: "OMR", USD: "$", EUR: "€" };

const detectCurrency = () => {
  try {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone || "";
    const map = {
      "Asia/Dubai": "AED", "Asia/Riyadh": "SAR", "Asia/Kuwait": "KWD",
      "Asia/Bahrain": "BHD", "Asia/Qatar": "QAR", "Asia/Muscat": "OMR",
    };
    if (map[tz]) return map[tz];
    if (tz.startsWith("Europe/")) return "EUR";
    if (tz.startsWith("America/")) return "USD";
  } catch (e) { logger.warn("timezone detection failed", e); }
  return "AED";
};

const readPref = (key) => {
  try { return localStorage.getItem(key); } catch (e) { logger.warn("prefs unavailable", e); return null; }
};
const writePref = (key, value) => {
  try { localStorage.setItem(key, value); } catch (e) { logger.warn("prefs unavailable", e); }
};

const convertAmount = (aed, currency) => Math.round((Number(aed) || 0) * (CURRENCY_RATES[currency] || 1) * 100) / 100;

const formatMoney = (aed, currency, tbaText) => {
  if (aed == null || Number(aed) <= 0) return tbaText;
  const n = convertAmount(aed, currency).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 2 });
  if (currency === "USD") return `$${n}`;
  if (currency === "EUR") return `€${n}`;
  return `${CURRENCY_SYMBOL[currency]} ${n}`;
};

// Pick a localized field (e.g. name_ar) with English fallback.
const localized = (obj, base, lang) => (obj ? obj[`${base}_${lang}`] || obj[`${base}_en`] || "" : "");

const translate = (lang, key) => translations[lang][key] ?? translations.en[key] ?? key;

const applyDocumentLang = (lang) => {
  document.documentElement.setAttribute("lang", lang);
  document.documentElement.setAttribute("dir", lang === "ar" ? "rtl" : "ltr");
};

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => readPref("omr_lang") || "en");
  const [currency, setCurrencyState] = useState(() => readPref("omr_currency") || detectCurrency());

  useEffect(() => { applyDocumentLang(lang); writePref("omr_lang", lang); }, [lang]);
  useEffect(() => { writePref("omr_currency", currency); }, [currency]);

  const setCurrency = (c) => { if (CURRENCIES.includes(c)) setCurrencyState(c); };
  const t = (key) => translate(lang, key);
  const value = {
    lang, setLang, t,
    toggle: () => setLang((l) => (l === "en" ? "ar" : "en")),
    dir: lang === "ar" ? "rtl" : "ltr",
    loc: (obj, base) => localized(obj, base, lang),
    emirates: emirates_en,
    emirateLabel: (e) => (lang === "ar" ? emirates_ar[e] || e : e),
    currency, setCurrency, currencies: CURRENCIES, rates: CURRENCY_RATES,
    convert: (aed) => convertAmount(aed, currency),
    money: (aed) => formatMoney(aed, currency, t("price_tba")),
  };

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};

export const useLang = () => useContext(LanguageContext);
